import React from 'react';
import TextInput from '../../components/forms/TextInput';
import usersStorage from './usersStorage';

function UserFieldEdit({
  placeholder, id, field, ...rest
}) {
  return (
    <TextInput
      {...rest}
      onChange={(e) => usersStorage.changeUserField(id, field, e.target.value)}
      placeholder={placeholder}
    />
  );
}

UserFieldEdit.propTypes = {};

export default UserFieldEdit;
